import { render, staticRenderFns } from "./ModalAjoutProduit.vue?vue&type=template&id=28a182e5&scoped=true&"
import script from "./ModalAjoutProduit.vue?vue&type=script&lang=js&"
export * from "./ModalAjoutProduit.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjoutProduit.vue?vue&type=style&index=0&id=28a182e5&lang=scss&scoped=true&"
import style1 from "./ModalAjoutProduit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a182e5",
  null
  
)

export default component.exports